<template>
    <!-- 普通下拉框选择 -->
    <div class="wk-input wk-input-box dropDown-slt-box posi-relative ">
        <span class="input-left-label" v-if="label">{{label}}</span>
        <!-- 下拉框 盒子 -->
        <div class="dropDown-container posi-relative">
            <!--下拉框的 显示框-->
            <div class="dropDown-title dropDown-slt posi-relative" @click="titleCliCk">
                <!-- 已选择某个选项 -->
                <p v-if="sltValueList.length" class="dropDown-title-name ft-size-16 dropDown-slt"> {{showInfo}} </p>
                <!-- <input v-if="sltValueList.length" class="dropDown-title-name ft-size-16 dropDown-slt" type="text" v-model="showInfo"> -->
                <!-- 否则 未选择 -->
                <p v-else class="dropDown-title-placeholder ft-size-16 dropDown-slt"> 请选择{{label||placeholder}} </p>
                <!-- 在 readonly 下 启用 -->
                <p v-if="readonly===''" class="disabled posi-absolute"></p>
                <!-- 尾部 三角号 icon -->
                <p class="posi-absolute dropDown-title-sanjiao dropDown-slt">
                    <img src="../../assets/img/dropdow-icon.png" class="dropDown-title-sanjiao dropDown-slt">
                </p>
            </div>
            <div class="dropDown-item-list-box posi-absolute" v-if="isShowBox">
                <!--下拉框的选项-->
                <ul class="dropDown-item-list dropDown-slt flex">
                    <li v-if="dataList==null" class="dropDown-item not-data"> 
                        <span class="txt-999"> 暂无数据 </span>
                    </li> 
                    <!-- 如果数据是 key 和 value 的形式 -->
                    <li v-else-if="dataListType == 'obj'" v-for="(item,k) in dataList" @click="itemClick(k)" :key='k' 
                        class="dropDown-item flex dropDown-slt"> 
                        <img v-if="k==sltValueList[k]" class="dropDown-slt" src="../../assets/img/fxk_ygx.png">
                        <img v-else class="dropDown-slt" src="../../assets/img/fxk_wgx.png">
                        <span class="dropDown-slt">{{k}}{{item}} {{sltValueList[k]}}</span>
                    </li>   
                    <!-- 如果数据是 数组形式 -->
                    <li v-else v-for="(item,k) in dataList" @click="itemClick(k)" :key='k' class="dropDown-item flex dropDown-slt"> 
                        <img v-if="item[optionVal]===sltValueList[k]" class="dropDown-slt" src="../../assets/img/fxk_ygx.png">
                        <img v-else class="dropDown-slt" src="../../assets/img/fxk_wgx.png">
                        <span class="dropDown-slt"> {{item[optionlabel]}}</span>
                    </li> 
                </ul>
                <p class="btn-box txt-center dropDown-slt">
                    <btn-middle @click="okHandler" btnTxt="确定"/> 
                </P>
            </div>    
        </div>
        <!-- 右侧提示 -->
        <div class="right-tip posi-absolute flex-dire-center">
            <slot> </slot>
        </div>
    </div>			
</template>

<script>
    export default {
        props: ['label','value','id','type','readonly','dataList','optionlabel','optionVal','placeholder'],
        mounted(){
            this.initHandler(this);  
        },
        data(){
            return{
                showInfo:'',
                sltLabelList:[], //当前选中的名称
                sltValueList:[], //当前选中的值
                dataListType:'', //数据类型
                isShowBox:false
            }
        },
        beforeDestroy() {
            window.removeEventListener('click', this.windowHanlderOfSlt);
        },
        watch:{
            dataList(){
                 
            }
        },
        methods:{
            // title 单击事件
            titleCliCk(){
                this.isShowBox = !this.isShowBox;
            },
            // option选择事件
            itemClick(index){
                if(this.dataListType == 'obj'){
                    // 如果没有包含此选项
                    if(!this.sltValueList.includes(index)){
                        this.$set(this.sltLabelList,index,this.dataList[index]);
                        this.$set(this.sltValueList,index,index);
                    }else{
                        this.delItem(this,index);
                    }
                }else if( this.dataListType == 'arr'){
                    // 如果没有包含此选项
                    if(!this.sltValueList.includes(this.dataList[index][this.optionVal])){
                        this.$set(this.sltLabelList,index,this.dataList[index][this.optionlabel]);
                        this.$set(this.sltValueList,index,this.dataList[index][this.optionVal]);
                    }else{
                        this.delItem(this,index);
                    }
                }   
                this.updateShow();  // 更细显示 
            },
            // 删除某一项
            delItem(that,index){
                //如果已经包含次选项,则遍历后删除
                let numTmp = null;
                if(this.dataListType == 'obj'){
                    this.sltLabelList.map((val,k) => {
                        this.dataList[index] == val ? numTmp = k : '';
                    });
                }else{
                    // console.log("sltLabelList",sltLabelList)
                    this.sltLabelList.map((val,k) => {
                        this.dataList[index][this.optionlabel] == val ? numTmp = k : '';
                    });
                }
                this.sltLabelList.splice(numTmp,1);
                this.sltValueList.splice(numTmp,1);
                this.updateShow();   // 更细显示
            },
            // 更细显示
            updateShow(){
                this.showInfo = '';
                //更新显示
                this.sltLabelList.map((val,k) => {
                    val ? this.showInfo += val + ',' : ''; 
                })
                this.showInfo != ''?this.showInfo = this.showInfo.substr(0,this.showInfo.length-1):'';
                //更新 v-model 显示
                let modelVal = '';
                this.sltValueList.map((val,k) => {
                    val ? modelVal += val + ',' : ''; 
                })
                modelVal != '' ? modelVal = modelVal.substr(0,modelVal.length-1):'';
                this.$emit('input',modelVal)
            },
            // 确定按钮点击事件
            okHandler(){
                this.isShowBox = false;
            },
            // window 点击事件
            windowHanlderOfSlt(e){
                let target = e.target;
                // 如果点击的 不是 title 和 item 都隐藏
                if( target.className.indexOf('dropDown-slt') < 0 ){
                    this.isShowBox = false;
                }
            },
            // 页面初始化数据
            initHandler(that){
                Array.isArray(that.dataList) ? that.dataListType = 'arr' : that.dataListType = 'obj';
                //如果默认有显示值
                that.showSlt(that);
                // 绑定 window 事件
                window.addEventListener('click', that.windowHanlderOfSlt);
            },
            // 显示的默认选中的信息
            showSlt(that){ 
                if(!that.value){
                    return; //如果没值则返回
                }
                // 如果数据是 对象
                // if(that.this.dataListType == 'obj'){
                //     // 遍历出当前的 默认选中的 银行卡信息
                //     for(let k in that.dataList){
                //         if(k == that.value){
                            
                //         }
                //     }
                // }else{
                //     // 遍历出当前的 默认选中的 银行卡信息
                //     that.dataList.map((val,k)=>{
                //         if(val[that.optionVal] == that.value){
                            
                //         }
                //     })  
                // }
            }
        }
    }
</script>

<style scoped lang="less">
    .dropDown-slt-box{
        margin:.9rem 0;
        // 下来框盒子
        .dropDown-container{
            width: 100%;
            // 下拉框的 title
            .dropDown-title{
                width:100%;
                height: 1.8rem;
                padding:0 2.5rem 0 .5rem;
                line-height: 1.7rem;
                border: 1px solid #d1d1d1;
                cursor:pointer; 
                // 未选择时提示
                .dropDown-title-placeholder{
                    color:#cacaca;
                }
                // 已选择的某项
                .dropDown-title-name,.dropDown-title-placeholder{
                    width: 100%;
                    overflow: hidden;
                }
                // readonly 下启用
                p.disabled{
                    top:0;
                    right:0;
                    width:100%;
                    height:1.7rem;
                    background:rgba(245, 247, 250, .1);
                    z-index: 3;
                }
                // 三角号的icon
                p.dropDown-title-sanjiao{
                    top:0;
                    right:0;
                    bottom:0;
                    width:2rem;
                    background: #F8F8F8;
                    border-left:.05rem solid #D6D6D6;
                    text-align: center;
                } 
            }
             // 下拉选择项 h盒子
            .dropDown-item-list-box{
                min-height: 4.9em;
                top:2.1rem;
                width: 136%;
                border:.05rem solid #D1D1D1;
                box-shadow:0 2px 9px 0 rgba(205,200,200,0.48);
                // 下拉选择项
                .dropDown-item-list{
                    width:100%;
                    min-height: 1.7em;
                    max-height:9rem;
                    padding:.85rem  0 0 .75rem ;
                    overflow: auto;
                    flex-wrap: wrap;
                    background: #fff;
                    z-index: 2;
                    background: #FAFAFA;
                    li{
                        height: .8rem;
                        margin:0 .9rem .75rem 0;
                        line-height: .8rem;
                        cursor: pointer;
                        img{
                            width:.7rem;
                            height:.7rem;
                            margin: .05rem .5rem 0 0;
                        }
                    }               
                    li.not-data{
                        background:#f3f3f3;
                        border:.05rem solid #D6D6D6;
                        border-bottom: none;
                    }
                }
                // 确定按钮
                p.btn-box{
                    border-top:.05rem solid #D1D1D1;
                    width: 90%;
                    height:2.5rem;
                    margin: 0 auto;
                    line-height: 2.5rem;    
                }
            }     
        }
        // 右侧提示
        .right-tip{
            top:0;
            left:100%;
            bottom: .1rem;
            padding-left:.5rem;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/BaseCpts/wkSelectMul.vue